import { z } from "zod";
import { type ParserType, parser } from "./parser";

export type DatetimeString = ParserType<typeof DatetimeString>;
export const DatetimeString = parser(z.iso.datetime());

const datetimeSchema = z.date();
export type Datetime = z.output<typeof datetimeSchema>;
export const Datetime = Object.freeze({
  ...parser(datetimeSchema),
  codec: z.codec(DatetimeString.schema, datetimeSchema, {
    decode: (value: string) => new Date(value),
    encode: (value: Date) => value.toISOString(),
  }),
  formatIsoLocal: (date: Datetime) => {
    return new Date(date.getTime() - date.getTimezoneOffset() * 60000)
      .toISOString()
      .slice(0, -1);
  },
  formatPretty: (date: Datetime) => {
    const format = new Intl.DateTimeFormat(undefined, {
      dateStyle: "medium",
      timeStyle: "short",
    });
    return format.format(date);
  },
});

const datetimeLocalStringSchema = z.iso.datetime({ local: true });
export type DatetimeLocalString = ParserType<typeof DatetimeLocalString>;
// TODO: might be getting time to make the "model" utility types.
export const DatetimeLocalString = Object.freeze({
  ...parser(datetimeLocalStringSchema),
  // Codec from and to backend type, which is DatetimeString.
  codec: z.codec(DatetimeString.schema, datetimeLocalStringSchema, {
    decode: (value: string) => Datetime.formatIsoLocal(new Date(value)),
    encode: (value: string) => new Date(value).toISOString(),
  }),
});
